module.exports = __webpack_public_path__ + "img/icon_manejo_de_parametros_sistema.46fce086.svg";